import { render, staticRenderFns } from "./SmsTemplatesListing.vue?vue&type=template&id=77c8317e"
import script from "./SmsTemplatesListing.vue?vue&type=script&lang=js"
export * from "./SmsTemplatesListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports